const FormatService = {
  round: function(val, places=2) {
    return isNaN(val) ? '-' : (Math.round((val + Number.EPSILON) * Math.pow(10, places)) / Math.pow(10, places));
  },
  pluralify: function(val, one, some, many) {
    const v = parseInt(val);
    //4, mesiac, mesiace, mesiacov
    if (v===1){
      return one;
    } else if (v<5){
      return some;
    } else if (v>4){
      return many;
    }
    return one;
  },
  dateFromTimestamp: function(val, IntlFormatOptions = null) {
    let _format = IntlFormatOptions ? IntlFormatOptions : {
      year: "numeric",
      month: "short",
      day: "numeric"
    };
    return new Intl.DateTimeFormat("sk-SK", _format).format(val).replaceAll(' ', '');
  },
  calendarDefaults: function(overrides = {}){
    return Object.assign({},
      {
        firstDayOfWeek: 1,
        daysOfWeek: true,
        locale: 'sk-SK',
        size: "medium"
      }, overrides);
  },
  formatNumber: function(value=null, currency=null){
    if (value!==null && !isNaN(value)) {
      let opt = {
        minimumFractionDigits: 2
      };
      if (currency){
        opt['style'] = 'currency';
        opt['currency'] = currency;
      }
      return new Intl.NumberFormat('sk-SK', opt).format(value);
    }
    return value;
  }
};

export default FormatService;
